import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'
import AppLayout from './App'
import { getAccessToken, getRefreshToken, refreshAccessToken } from './lib/auth'
import { fetchMe } from './lib/api'
import { setCourierScope } from './lib/courierScope'
import { RouteErrorPage } from './components/PageLoading'
import { redirect } from 'react-router-dom'

const FaqPage = lazy(() => import('./pages/pwa/FaqPage'))
const LoginPage = lazy(() => import('./pages/pwa/LoginPage'))
const DeliveriesPage = lazy(() => import('./pages/pwa/DeliveriesPage'))
const DeliveryDetailPage = lazy(() => import('./pages/pwa/DeliveryDetailPage'))
const PodPage = lazy(() => import('./pages/pwa/PodPage'))
const PreferencesPage = lazy(() => import('./pages/pwa/PreferencesPage'))
const ChangePasswordPage = lazy(() => import('./pages/pwa/ChangePasswordPage'))
const NotificationsPage = lazy(() => import('./pages/pwa/NotificationsPage'))
const AboutPage = lazy(() => import('./pages/pwa/AboutPage'))
const SyncPage = lazy(() => import('./pages/pwa/SyncPage'))

async function requireCourier() {
  let token = getAccessToken()
  if (!token && getRefreshToken()) token = await refreshAccessToken()
  if (!token) throw redirect('/app/login')
  const me = await fetchMe()
  if (!me.memberships.some(m => m.is_active && m.role === 'courier')) {
    throw new Response(null, { status: 403, statusText: 'Seu perfil não tem acesso ao aplicativo do entregador.' })
  }
  setCourierScope(me)
  // A manager+courier keeps the courier context when entering /app. The
  // backend remains the authority for the active account and delivery scope.
  return null
}

export const routes: RouteObject[] = [
  { path: '/', loader: () => redirect('/app/login') },
  // Keep /login as a convenient local entry point while the deployed PWA uses /app/.
  { path: '/login', loader: () => redirect('/app/login') },
  { path: '/app/ajuda', element: <FaqPage />, errorElement: <RouteErrorPage /> },
  { path: '/app/login', element: <LoginPage />, errorElement: <RouteErrorPage /> },
  { path: '/app', element: <AppLayout />, errorElement: <RouteErrorPage />, loader: requireCourier, children: [
    { index: true, element: <DeliveriesPage /> },
    { path: 'history', element: <DeliveriesPage /> },
    { path: 'sync', element: <SyncPage /> },
    { path: 'deliveries/:id', element: <DeliveryDetailPage /> },
    { path: 'deliveries/:id/pod', element: <PodPage /> },
    { path: 'account/preferences', element: <PreferencesPage /> },
    { path: 'account/change-password', element: <ChangePasswordPage /> },
    { path: 'account/notifications', element: <NotificationsPage /> },
    { path: 'account/about', element: <AboutPage /> },
  ] },
]
